__turbopack_context__.v({
  "className": "xWTHKW_className",
  "variable": "xWTHKW_variable",
});
